export const rumiTheme = {
  fontFamily: {
    sans: 'Inter, Arial, sans-serif',
    headings: 'Inter Tight, Arial, sans-serif',
    sidebar: 'Roboto Condensed, Arial, sans-serif',
  },
  colors: {
    rumi: {
      virgoGreen: {
        800: '#3C4A2C',
      },
      boneWhite: {
        200: '#FBFAF6',
      },
      taupe: {
        500: '#e9e7de',
      },

      brandGreen: {
        900: '#233720',
        800: '#2E492A',
        500: '#91A096',
        400: '#BDC4BF',
        300: '#D3D9D5',
      },
      jungleGreen: {
        900: '#152712',
        700: '#727D71',
        500: '#99A297',
        300: '#D1D4D0',
      },

      silverGreen: {
        500: '#C2CAB6',
        300: '#E1E5DB',
        250: '#EDEFE9',
        200: '#F2F4F0',
      },
      teaGreen: {
        500: '#D7E7B7',
        400: '#E3EECD',
        200: '#F0F7E3',
      },
      harvestGreen: {
        500: '#CED0B5',
      },
      tan: {
        400: '#E6E1DA',
        300: '#EFECE7',
        200: '#F7F5F1',
      },
      gold: {
        700: '#B98A50',
      },
      grey: {
        800: '#383838',
        750: '#606060',
        700: '#1C1D18',
        650: '#919191',
        600: '#B0B0B0',
        500: '#DEDEDE',
        400: '#EDEDED',
        300: '#F2F2F2',
        200: '#F6F6F6',
        100: '#F8F8F8',
      },
      greyGreen: {
        900: '#1A2118',
        800: '#464D46',
        700: '#757A75',
        600: '#A3A6A3',
      },
      red: {
        900: '#8f342b',
        800: '#A21D03',
        700: '#C5442A',
        500: '#D86149',
        200: '#EFC0B6',
      },
      orange: {
        800: '#FD7F00',
        600: '#FFA142',
        500: '#FFAA55',
        200: '#FFECD2',
        100: '#FAF4ED',
      },
      orangeDark: {
        500: '#D18F4B',
      },
      yellow: {
        500: '#FFCE55',
      },
      greenSuccess: {
        500: '#81a784',
      },
      blue: {
        700: '#3F7594',
        500: '#7FADC7',
        300: '#C3DCE8',
        100: '#EDF3F6',
      },
    },
  },
}
